// extracted by mini-css-extract-plugin
export default {"root":"WrapTable_root__bdYze","container":"WrapTable_container__nwWut","tr":"WrapTable_tr__90pur","yenText":"WrapTable_yenText__-arzq"};